import React, { Component } from 'react';
import { connect } from 'react-redux';
import OpenNoticeProductItem from '../../../views/app/common/OpenNoticeProductItem';
import { appActions } from '../../../store/modules/app';

class OpenNoticeProductItemContainer extends Component {
  render() {
    return <OpenNoticeProductItem {...this.props} />;
  }
}

const mapDispatchToProps = {
  openNoticeProductItemListModal: appActions.openNoticeProductItemListModal,
};

export default connect(null, mapDispatchToProps)(OpenNoticeProductItemContainer);
